import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Analytics } from '@vercel/analytics/react';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './i18n';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import RedefinirSenha from './pages/RedefinirSenha';
import Dashboard from './pages/Dashboard';
import Campanhas from './pages/Campanhas';
import NovaCampanha from './pages/NovaCampanha';
import Contatos from './pages/Contatos';
import Envios from './pages/Envios';
import WhatsApp from './pages/WhatsApp';
import Configuracoes from './pages/Configuracoes';
import Admin from './pages/Admin';
import Perfil from './pages/Perfil';
import Conversas from './pages/Conversas';
import ConfiguracaoIA from './pages/ConfiguracaoIA';
import Creditos from './pages/Creditos';
import Metricas from './pages/Metricas';
import RenewalBanner from './components/RenewalBanner';
import MigrationReconnectModal from './components/MigrationReconnectModal';
import PlanExpiredModal from './components/PlanExpiredModal';
import './App.css';

function Layout({ children }) {
  return (
    <div className="app-shell">
      <Navbar />
      <RenewalBanner />
      <MigrationReconnectModal />
      <PlanExpiredModal />
      <main className="app-main">
        {children}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
      <Analytics />
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              borderRadius: '10px',
              background: '#1c1f2a',
              color: '#fff',
              fontSize: '14px',
              padding: '10px 14px',
              boxShadow: '0 12px 32px rgba(15,17,32,0.18)'
            },
            success: { iconTheme: { primary: '#22c55e', secondary: '#fff' } },
            error:   { iconTheme: { primary: '#ef4444', secondary: '#fff' } }
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/redefinir-senha" element={<RedefinirSenha />} />
          <Route path="/" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
          <Route path="/campanhas" element={<PrivateRoute><Layout><Campanhas /></Layout></PrivateRoute>} />
          <Route path="/campanhas/nova" element={<PrivateRoute><Layout><NovaCampanha /></Layout></PrivateRoute>} />
          <Route path="/contatos" element={<PrivateRoute><Layout><Contatos /></Layout></PrivateRoute>} />
          <Route path="/grupos" element={<Navigate to="/contatos" />} />
          <Route path="/envios" element={<PrivateRoute><Layout><Envios /></Layout></PrivateRoute>} />
          <Route path="/metricas" element={<PrivateRoute><Layout><Metricas /></Layout></PrivateRoute>} />
          <Route path="/whatsapp" element={<PrivateRoute><Layout><WhatsApp /></Layout></PrivateRoute>} />
          <Route path="/configuracoes" element={<PrivateRoute><Layout><Configuracoes /></Layout></PrivateRoute>} />
          <Route path="/perfil" element={<PrivateRoute><Layout><Perfil /></Layout></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute><Layout><Admin /></Layout></PrivateRoute>} />
          <Route path="/conversas" element={<PrivateRoute><Layout><Conversas /></Layout></PrivateRoute>} />
          <Route path="/ia" element={<PrivateRoute><Layout><ConfiguracaoIA /></Layout></PrivateRoute>} />
          <Route path="/creditos" element={<PrivateRoute><Layout><Creditos /></Layout></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}